import React from 'react';
import { FormattedMessage } from 'react-intl';

import AdUnitWithRoute, { AdUnitProps } from '../google-dfp';

export const ForumRectangle = (props: AdUnitProps) => {
    return (
        <AdUnitWithRoute
            adUnitCode='forum-rectangle-top' //there is also forum-rectangle-bottom, override via props
            sizes={['fluid', [300, 250], [336, 280], [480, 300]]}
            sizeMapping={[
                [
                    [0, 0],
                    ['fluid', [300, 250]],
                ],
                [
                    [336, 0],
                    ['fluid', [336, 280]],
                ],
                [
                    [1024, 0],
                    ['fluid', [300, 250], [336, 280], [480, 300]],
                ],
            ]}
            label={<FormattedMessage id='SPONSOR_OF_FORUM' />}
            {...props}
        />
    );
};

interface ZoznamProps extends AdUnitProps {
    position: string;
}

export const ZoznamBoxin = (props: ZoznamProps) => {
    const { position } = props;

    return (
        <AdUnitWithRoute
            adUnitCode={position === 'top' ? '/60012913/Mojasvadba-boxin-1' : '/60012913/Mojasvadba-boxin-2'}
            overrideAdUnitCode={true}
            sizes={[
                [300, 100],
                [300, 250],
                [336, 280],
                [300, 300],
            ]}
            sizeMapping={[
                [
                    [0, 0],
                    ['fluid', [300, 100], [300, 250]],
                ],
                [
                    [336, 0],
                    ['fluid', [300, 100], [300, 250], [336, 280]],
                ],
                [
                    [1024, 0],
                    ['fluid', [300, 100], [300, 250], [336, 280], [300, 300]],
                ],
            ]}
            label={<FormattedMessage id='SPONSOR_OF_FORUM' />}
            {...props}
        />
    );
};

export const ZahradaBoxin = (props: AdUnitProps) => {
    return (
        <AdUnitWithRoute
            overrideAdUnitCode
            adUnitCode={'/1023789/zahrada-boxin'}
            divAdId='div-gpt-ad-1634134512640-0'
            sizes={['fluid', [300, 300]]}
            sizeMapping={[]}
            {...props}
        />
    );
};
